import { useSearchParams, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import type { ViewType } from "./types";
import { buildWorkspaceDashboardPath } from "@/features/Workspaces/workspaceRoutes";

const useView = (uuid: string | undefined, userViews: ViewType[]) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { group, workspace } = useParams();

  const view = searchParams.get("view");

  const switchView = (newView: string) => {
    if (!uuid || !group || !workspace) return;
    navigate(
      buildWorkspaceDashboardPath({
        group,
        workspace,
        uuid,
        view: newView,
      }),
    );
  };

  useEffect(() => {
    // if no view navigate to the first view
    if (!view && userViews.length && uuid) {
      const defaultView = userViews[0].name;
      switchView(defaultView);
    }
  }, [uuid, userViews, view, searchParams]);

  return { view, switchView };
};

export default useView;
